const URL_PREFIX = 'content/experience-fragments/waitrosegroceriescms/';

const createExperienceFragment = <T extends { key: string; location: string }>(
  config: T,
): { key: T['key']; location: T['location']; fullPath: `${typeof URL_PREFIX}${T['key']}` } => ({
  key: config.key,
  location: config.location,
  fullPath: `${URL_PREFIX}${config.key}`,
});

export const MIDDLE_MEGA_MENU = createExperienceFragment({
  key: 'menu/middle-mega-menu/master',
  location: 'middleMegaMenu',
} as const);

export const SEASONAL_MENU = createExperienceFragment({
  key: 'menu/seasonal-menu/seasonal-menu-content/master',
  location: 'seasonalMenu',
} as const);

export const SITE_WIDE_BANNER = createExperienceFragment({
  key: 'Site-Wide-Banner/Site-Banner-Content/master',
  location: 'siteWideBannerContent',
} as const);

export const RESCUE_POD_BANNER = createExperienceFragment({
  key: 'rescue-pod-banner/plp-search/master',
  location: 'rescuePodBanner',
} as const);
